/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsCompanyEditCtrl
 */
angular.module('mercury.modules.settings.company')
.controller('SettingsCompanyEditCtrl', ["Company", "dialog", "$filter", "$http", "$scope", "$state", "$stateParams", "title", "userinfo", function(Company, dialog, $filter, $http, $scope, $state, $stateParams, title, userinfo) {
  $scope.permissionList = [
    {key: 'Manager', label: 'Manager'},
    {key: 'Report', label: 'Reports'},
    {key: 'Cashup', label: 'Cashups'},
    {key: 'Stock', label: 'Stock'},
    {key: 'StockShare', label: 'Stock Sharing'},
    {key: 'Time', label: 'Timeclock'},
    {key: 'Payroll', label: 'Payroll'},
    {key: 'Salary', label: 'Salary'}
  ];

  $scope.userPermissionModel = {};
  $scope.invitePermissionModel = {};
  $scope.transferPending = false;

  $scope.loading = Company.get($stateParams.id);
  $scope.loading.then(function(response) {
    response.userPermissions = $filter('orderBy')(response.userPermissions, 'userFullName');
    angular.forEach(response.userPermissions, function(userPermission) {
      $scope.userPermissionModel[userPermission.id] = {};
      angular.forEach(userPermission.permissions, function(permission) {
        $scope.userPermissionModel[userPermission.id][permission] = true;
      });
    });

    angular.forEach(response.invites, function(invitePermission) {
      $scope.invitePermissionModel[invitePermission.id] = {};
      angular.forEach(invitePermission.permissions, function(permission) {
        $scope.invitePermissionModel[invitePermission.id][permission] = true;
      });
    });

    $scope.company = response;
    title.set($scope.company.fullName);
  });

  $scope.userPermissionChanged = function(userPermission, userPermissionIndex, permissionKey) {
    userPermission.permissions = [];
    angular.forEach($scope.permissionList, function(permission) {
      if ($scope.userPermissionModel[userPermission.id][permission.key] === true) {
        userPermission.permissions.push(permission.key);
      }
    });

    if (userPermission.permissions.length > 0) {
      Company.updatePermission(userPermission, $scope.company.id);
    } else {
      dialog.confirm('Removing the last permission will delete this user from the Company. Do you wish to continue?')
      .then(function(result) {
        if (result) {
          $scope.removeUserPermission(userPermission, userPermissionIndex);
        } else {
          $scope.userPermissionModel[userPermission.id][permissionKey] = true;
        }
      });
    }
  };

  $scope.removeUserPermission = function(userPermission, index) {
    if (userPermission.userEmail == userinfo.userDetails().email) {
      dialog.confirm('You are about to remove yourself from this company. Do you wish to continue?')
      .then(function(result) {
        if (result) {
          Company.removePermission(userPermission, $scope.company.id)
          .then(function() {
            userinfo.removeCompany($stateParams.id, $scope.company.id);
            $state.go('Settings.CompanyList', {}, {reload: true});
          });
        }
      });
    } else {
      Company.removePermission(userPermission, $scope.company.id)
      .then(function() {
        $scope.company.userPermissions.splice(index, 1);
      });
    }
  };

  $scope.invitePermissionChanged = function(invitePermission, invitePermissionIndex, permissionKey) {
    invitePermission.permissions = [];
    angular.forEach($scope.permissionList, function(permission) {
      if ($scope.invitePermissionModel[invitePermission.id][permission.key] === true) {
        invitePermission.permissions.push(permission.key);
      }
    });

    if (invitePermission.permissions.length > 0) {
      Company.updateInvite(invitePermission, $scope.company.id);
    } else {
      dialog.confirm('Removing the last permission will delete this invite from the Company. Do you wish to continue?')
      .then(function(result) {
        if (result) {
          $scope.removeInvite(invitePermission, invitePermissionIndex);
        } else {
          $scope.invitePermissionModel[invitePermission.id][permissionKey] = true;
        }
      });
    }
  };

  $scope.sendInvite = function(form) {
    form.$setSubmitted();
    if (form.$invalid) {
      return;
    }

    $scope.errorState = null;

    $scope.savingInvite = Company.createInvite($scope.invite, $scope.company.id);
    $scope.savingInvite.then(function(response) {
      $scope.company.invites.push(response);

      $scope.invitePermissionModel[response.id] = {};
      angular.forEach(response.permissions, function(permission) {
        $scope.invitePermissionModel[response.id][permission] = true;
      });

      dialog.close();
    }, function(response) {
      if (response.data.modelState) {
        $scope.modelState = response.data.modelState;
      }
    });
  };

  $scope.sendInviteOpen = function() {
    $scope.errorState = null;
    $scope.invite = {
      name: '',
      email: '',
      permissions: ['Report']
    };

    dialog.open({
      scope: $scope,
      templateUrl: 'modules/settings/company/invite.tpl.html'
    });
  };

  $scope.removeInvite = function(invite, index) {
    Company.removeInvite(invite, $scope.company.id)
    .then(function() {
      $scope.company.invites.splice(index, 1);
    });
  };

  $scope.isOwner = function(user) {
    return user.userId == $scope.company.ownerId;
  };

  $scope.currentUserIsOwner = function() {
    var userdetails = userinfo.userDetails();

    return userdetails.id == $scope.company.ownerId;
  };

  $scope.transferAvailable = function(user) {
    if ($scope.transferPending || user.userId == $scope.company.ownerId) {
      return false;
    }
    return true;
  };

  $scope.transferToolTip = function(user) {
    if (user.userId == $scope.company.ownerId) {
      return 'You are currently the owner of this company';
    }
    if (user.userId == $scope.company.pendingOwnerId) {
      return 'Cancel Ownership Transfer';
    }
    return 'Transfer ownership of ' + $scope.company.fullName + ' to this user';
  };

  $scope.transferText = function(user) {
    if (user.userId == $scope.company.ownerId) {
      return 'Owner';
    }
    if (user.userId == $scope.company.pendingOwnerId) {
      return 'Cancel Transfer';
    }
    return 'Transfer ownership';
  };

  $scope.transferOwner = function(user) {
    if (user.userId == $scope.company.ownerId) {
      return;
    } else if (user.userId == $scope.company.pendingOwnerId) {
      Company.cancelTransferOwner($scope.company.id).then(function() {
        $state.go('Settings.CompanyEdit', {id: $stateParams.id}, {reload: true});
      });
    } else {
      $scope.transferPending = true;
      Company.transferOwner($scope.company.id, user.userId).then(function() {
        $state.go('Settings.CompanyEdit', {id: $stateParams.id}, {reload: true});
      });
    }
  };

  $scope.revokeSupportInvite = function() {
    $scope.revokingSupport = Company.revokeSupport();
    $scope.revokingSupport.then(function() {
      $scope.company.hasSupportInvite = false;
    });
  };
}]);
